var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#5DBE62;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Grass",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st1",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st2",
    d: "M-2,4.8c-2.5-2.5-2.5-6.6,0-9.1c1.3-1.3,4.1-2,6.2-2.3C5.6-6.8,7.1-7,8.5-7l0,0 c0.2,1.6,0.2,3.3,0.2,5c0,2.4-0.4,5.6-1.7,6.9C4.9,7,1.5,7.4-1.1,5.6l2-2.5l3.2-0.7L1.5,2.1l1.7-1.7L5.1,0L3.6-0.5l1.5-2.7L3-0.8 L2.1-1.9L2.4,0L0.9,1.7L0.2-0.5l0,2.8L-1.9,5l0,0L-2,4.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,19c-0.4,0.4-0.9,0.8-1.6,1s-1.4,0.4-2.2,0.4c-0.9,0-1.6-0.2-2.3-0.6S40.4,19,40,18.2 c-0.4-0.7-0.5-1.6-0.5-2.5V15c0-1,0.2-1.9,0.5-2.6s0.8-1.3,1.4-1.7s1.4-0.6,2.2-0.6c1.2,0,2.1,0.3,2.8,0.8s1.1,1.4,1.2,2.5h-2 c-0.1-0.6-0.3-1-0.6-1.3s-0.7-0.4-1.3-0.4c-0.7,0-1.2,0.3-1.6,0.8S41.6,14,41.6,15v0.6c0,1,0.2,1.8,0.6,2.4s1,0.8,1.7,0.8 c0.8,0,1.3-0.2,1.6-0.5v-1.7h-1.9v-1.5h3.9V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53,16.7h-1.6v3.6h-2.1v-10H53c1.2,0,2.1,0.3,2.7,0.8c0.6,0.5,1,1.3,1,2.2c0,0.7-0.1,1.2-0.4,1.7 c-0.3,0.5-0.7,0.8-1.3,1.1l2.2,4.1v0.1h-2.2L53,16.7z M51.3,15H53c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1 S53.5,12,53,12h-1.6V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.8,18.3h-3.6l-0.7,2.1h-2.2l3.7-10H63l3.7,10h-2.2L63.8,18.3z M60.8,16.6h2.5L62,12.9L60.8,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.8,17.7c0-0.4-0.1-0.7-0.4-0.9s-0.8-0.4-1.5-0.7c-0.7-0.2-1.3-0.5-1.7-0.7c-1.1-0.6-1.7-1.4-1.7-2.5 c0-0.5,0.2-1,0.5-1.4c0.3-0.4,0.7-0.8,1.3-1c0.6-0.2,1.2-0.4,1.9-0.4c0.7,0,1.3,0.1,1.9,0.4s1,0.6,1.3,1.1c0.3,0.5,0.5,1,0.5,1.6 h-2.1c0-0.5-0.1-0.8-0.4-1.1s-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.3s-0.4,0.5-0.4,0.8c0,0.3,0.2,0.6,0.5,0.8 c0.3,0.2,0.8,0.4,1.4,0.6c1.2,0.4,2,0.8,2.5,1.3c0.5,0.5,0.8,1.2,0.8,1.9c0,0.9-0.3,1.5-1,2s-1.5,0.7-2.6,0.7 c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2c-0.3-0.5-0.5-1.1-0.5-1.7h2.1c0,1.1,0.7,1.6,2,1.6c0.5,0,0.9-0.1,1.1-0.3 S72.8,18,72.8,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.4,17.7c0-0.4-0.1-0.7-0.4-0.9s-0.8-0.4-1.5-0.7c-0.7-0.2-1.3-0.5-1.7-0.7c-1.1-0.6-1.7-1.4-1.7-2.5 c0-0.5,0.2-1,0.5-1.4c0.3-0.4,0.7-0.8,1.3-1c0.6-0.2,1.2-0.4,1.9-0.4c0.7,0,1.3,0.1,1.9,0.4s1,0.6,1.3,1.1c0.3,0.5,0.5,1,0.5,1.6 h-2.1c0-0.5-0.1-0.8-0.4-1.1s-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.3s-0.4,0.5-0.4,0.8c0,0.3,0.2,0.6,0.5,0.8 c0.3,0.2,0.8,0.4,1.4,0.6c1.2,0.4,2,0.8,2.5,1.3c0.5,0.5,0.8,1.2,0.8,1.9c0,0.9-0.3,1.5-1,2s-1.5,0.7-2.6,0.7 c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2c-0.3-0.5-0.5-1.1-0.5-1.7h2.1c0,1.1,0.7,1.6,2,1.6c0.5,0,0.9-0.1,1.1-0.3 S81.4,18,81.4,17.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.d9e2d7912366fca72c9a3119e5b29123.svg";
export { ForwardRef as ReactComponent };